// extracted by css-extract-rspack-plugin
export default {"readOnly":"FilterPickerBody-module__readOnly___QT3gf"};